module.exports = __webpack_public_path__ + "img/flag_sk.edb2e21.svg";